module.exports = __webpack_public_path__ + "media/application/images/icons/innovations/business-7c13b5bee6d80e4a8eb18e6d23ce15bd.svg";